import { Box } from "@mui/system";

const RatingResponse = ({ question, selectChoice, selections, themeColors }) => {
    return (
        <Box sx={{ marginBottom: 5, width: "100%" }}>
            <div className="grid grid-cols-11 gap-2 w-[700px]">
                {question.choices &&
                    question.choices.map((choice, index) => (
                        <Box
                            key={index}
                            style={{
                                backgroundColor:
                                    selections[question.id] == choice.value ? themeColors.primaryColor : "",
                            }}
                            className={`${
                                selections[question.id] == choice.value ? ` text-white` : ""
                            }   cursor-pointer flex items-center justify-center rounded-md border border-slate-300 w-12 h-12`}
                        >
                            <div>{choice.value}</div>
                        </Box>
                    ))}
                <div className="col-span-11 flex justify-between mt-3">
                    <div className="text-sm">Not good at all</div>
                    <div className="text-sm mr-2">Very good</div>
                </div>
            </div>
        </Box>
    );
};

export default RatingResponse;
